<template>
  <section class="col-12 col-xl-12 col-md-12 box-col-12">
    <div class="card item-work-wraper">
      <div class="card-header">Softskill & Hardskill</div>
      <div class="card-body">
        <template v-if="skill.softskill && skill.hardskill">
           <ItemSkill :label="`Softskill`" :item="skill.softskill"></ItemSkill>
           <ItemSkill :label="`Hardskill`" :item="skill.hardskill"></ItemSkill>
        </template>
       
      </div>

      <div class="card-action">
        <button v-b-modal.softskill_hardskill class="btn btn-block btn-action"><i class="fa fa-plus-circle mr-2" aria-hidden="true"></i>Add Softskill & Hardskill</button>
      </div>
    </div>

    <!-- Vertically centered Modal Component -->
    <b-modal
      id="softskill_hardskill"
      size="lg"
      width="100%"
      centered
      title="Add Softskill & Hardskill"
      ok-title="Save"
      cancel-title="Cancel"
      class="theme-modal"
      @ok="handleSubmit"
    >
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <h6 class="form-label">Softskill</h6>
            <b-form-tags v-model="form.softskill" placeholder="Softskill"></b-form-tags>
          </div>
        </div>

         <div class="col-md-12">
          <div class="form-group">
            <h6 class="form-label">Hardskill</h6>
            <b-form-tags v-model="form.hardskill" placeholder="Hardskill"></b-form-tags>
          </div>
        </div>

      </div>
    </b-modal>
  </section>
</template>

<script>
  import ItemSkill from './item/ItemSkill.vue';
  import { getDataProvinces } from "../../_services/data.service";
  import { submitSoftHardSkill, getDataSoftHardSkill } from "../../_services/profile.service";

  export default {
    components: {
      ItemSkill,
    },
    data() {
      return {
        dataSource :{
          status: [
            {
              name: 'Karyawan Kontrak',
              value: 'Karyawan Kontrak'
            },
            {
              name: 'Karyawan Tetap',
              value: 'Karyawan Kontrak'
            },
            {
              name: 'Kesepakatan Kerja Waktu Tertentu',
              value: 'Kesepakatan Kerja Waktu Tertentu'
            },
            {
              name: 'Magang',
              value: 'Magang'
            },
            {
              name: 'Mitra',
              value: 'Mitra'
            },
            {
              name: 'Probation',
              value: 'Probation'
            },
            {
              name: 'PRJB',
              value: 'PRJB'
            },
            {
              name: 'Traine',
              value: 'Traine'
            },
            {
              name: 'Volunteer',
              value: 'Volunteer'
            },
            {
              name: 'Lainya',
              value: 'Lainya'
            },
          ],
          provinces: ''
        },
        form : {
          id_user : '',
          softskill :[],
          hardskill : []
        },
        skill: []
      };
    },
    computed:{
    },
    mounted(){
      let user = JSON.parse(localStorage.getItem('user'));
      this.form.id_user = this.$route.query.id_user ?  this.$route.query.id_user : user.id;
      this.fetchDataSoftHardSkill( this.$route.query.id_user);

      let lang = localStorage.getItem('currentLanguage') ?  localStorage.getItem('currentLanguage') : process.env.VUE_APP_LANG;
      if (lang == 'en') {
        this.dataSource = {
          status: [
            {
              name: 'Contract employees',
              value: 'Karyawan Kontrak'
            },
            {
              name: 'Permanent employees',
              value: 'Karyawan Kontrak'
            },
            {
              name: 'Fixed Time Work Agreement',
              value: 'Kesepakatan Kerja Waktu Tertentu'
            },
            {
              name: 'Internship',
              value: 'Magang'
            },
            {
              name: 'Partner',
              value: 'Mitra'
            },
            {
              name: 'Probation',
              value: 'Probation'
            },
            {
              name: 'PRJB',
              value: 'PRJB'
            },
            {
              name: 'Traine',
              value: 'Traine'
            },
            {
              name: 'Volunteer',
              value: 'Volunteer'
            },
            {
              name: 'Other',
              value: 'Lainya'
            },
          ],
        };
      }
    },
    methods : {
      async fetchDataProvinces(){
        await getDataProvinces().then(res => {
          this.dataSource.provinces = res;
        });
      },
      async fetchDataSoftHardSkill(){
        this.skill = await getDataSoftHardSkill(this.form.id_user);
      },
      async handleSubmit(){
        await submitSoftHardSkill(this.form);
        this.fetchDataSoftHardSkill();
      }
    }
  };
</script>

<style lang="scss">
.item-work-wraper {
  padding: 0;
  .card-header {
    padding: 18px 25px !important;
    font-size: 1.1rem;
    font-weight: 500;
  }
  .item {
    flex-direction: column;
    h3 {
      font-size: 0.9rem;
      font-weight: 500;
    }
    h5 {
      font-size: 0.9rem;
      font-weight: 400;
    }
  }
  .card-body {
    padding: 18px 25px !important;
    gap: 1rem;

    max-height: 530px;
    height: 530px;
    overflow: auto;
    flex-direction: column;
  }

  .item-personal {
    -ms-flex: 0 0 20%;
    -webkit-box-flex: 0;
    flex: 0 0 20%;
    max-width: 20%;
    padding: 18px 25px;
    border-right: 2px solid #e9ecef;
  }

  .item-address {
    -ms-flex: 0 0 50%;
    -webkit-box-flex: 0;
    flex: 0 0 50%;
    max-width: 50%;
    padding: 18px 25px;
    border-right: 2px solid #e9ecef;
  }

  .item-minat {
    -ms-flex: 0 0 30%;
    -webkit-box-flex: 0;
    flex: 0 0 30%;
    max-width: 30%;
    padding: 18px 25px;
    display: flex;
    flex-direction: column;

    .item-hobie {
      flex: 1;
      h3 {
        font-size: 0.9rem;
        font-weight: 500;
      }

      .list-item {
        display: flex;
        flex-wrap: wrap;
        gap: 5px;
        .rounded {
          padding: 0.2rem 1rem;
          background: var(--theme-deafult);
          color: var(--theme-font);
          font-size: 0.7rem;
          border-radius: 1rem !important;
        }
      }
    }
  }

  .btn-action{
    border-top: 1px solid #E9ECEF;
    font-weight: 600;
    padding-top: .7rem;
    padding-bottom: .7rem;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    color: #1d1e26;
    .fa{
      font-size: 1rem;
    }
  }

  .card-body {
    display: flex;
    .d-flex {
      width: 100%;
    }
  }
}
</style>
